import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { accountDataLoad } from './manageAccount';

export const OPEN_UPDATE_DUAL_FORM_STATUS_MODAL = 'OPEN_UPDATE_DUAL_FORM_STATUS_MODAL';
export const CLOSE_UPDATE_DUAL_FORM_STATUS_MODAL = 'CLOSE_UPDATE_DUAL_FORM_STATUS_MODAL';
export const REQUEST_UPDATE_DUAL_FORM_STATUS = 'REQUEST_UPDATE_DUAL_FORM_STATUS';
export const RECIEVE_UPDATE_DUAL_FORM_STATUS = 'RECIEVE_UPDATE_DUAL_FORM_STATUS';
export const UPDATE_DUAL_FORM_STATUS_FAILURE = 'UPDATE_DUAL_FORM_STATUS_FAILURE';

function openUpdateDualFormStatusModal(checkStatus, accountId, accountNumber) {
  return {
    type: OPEN_UPDATE_DUAL_FORM_STATUS_MODAL,
    showModal: true,
    dualFormCheckStatus: checkStatus,
    dualFormSelectedAccountId: accountId,
    dualFormSeletedAccountNumber: accountNumber
  };
}

function closeUpdateDualFormStatusModal() {
  return {
    type: CLOSE_UPDATE_DUAL_FORM_STATUS_MODAL,
    showModal: false
  };
}

function request() {
  return {
    type: REQUEST_UPDATE_DUAL_FORM_STATUS
  };
}

function receive() {
  return {
    type: RECIEVE_UPDATE_DUAL_FORM_STATUS,
    updateDualFormStatusError: null
  };
}

function reject(updateDualFormStatusError) {
  return {
    type: UPDATE_DUAL_FORM_STATUS_FAILURE,
    updateDualFormStatusError: updateDualFormStatusError.message
  };
}

export function showUpdateDualFormStatusModal(checkStatus, accountId, accountNumber) {
  return (dispatch) => {
    dispatch(openUpdateDualFormStatusModal(checkStatus, accountId, accountNumber));
  };
}

export function hideUpdateDualFormStatusModal() {
  return (dispatch) => {
    dispatch(closeUpdateDualFormStatusModal());
  };
}

export function updateDualFormStatus(checkStatus, accountId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .updateDualFormStatus(accountId, checkStatus)
      .then((response) => {
        dispatch(receive(response.data));
        dispatch(closeUpdateDualFormStatusModal());
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
